import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Col, Form, Input, Row, DatePicker } from "antd";
import { PAGINATION } from "../../_redux/constant";
import _ from "lodash";
import { removeVietnameseTones } from "lib/admin";
import { tripodThunks } from "../../_redux/thunk";
import AppBaseSelect from "../../../../../core/components/baseSelect";
import { TIME_FORMAT_DATE_TIME } from "../../../app/_redux/constants";
import dayjs from "dayjs";
import TripodLogList from "../../components/tripod-log/tripodLogList";
import { convertObjToArrObj } from "../../../../../lib/util";

let timer = null;
function TripodLog() {
  const CARD_STYLE = {
    borderRadius: "0.42rem",
    boxShadow: "0px 0px 30px 0px rgba(82, 63, 105, 0.05)"
  };
  const today = new Date();
  const { RangePicker } = DatePicker;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const {
    device_ids,
    device_ips,
    verify_modes,
    checkin_types,
    sync_states,
    stations
  } = useSelector(state => state.tripod.tripodLog.filterData);
  const { data, total } = useSelector(
    state => state.tripod.tripodLog.tripodList
  );
  const [param, setParam] = useState({
    size: PAGINATION.size,
    page: PAGINATION.page,
    from: `${dayjs(today).format("YYYY-MM-DD")} 00:00:00`,
    to: `${dayjs(today).format("YYYY-MM-DD")} 23:59:59`
  });
  const dataSource = _.map(data, (item, index) => ({
    ...item,
    stt:
      param.page === 1 ? index + 1 : (param.page - 1) * param.size + index + 1
  }));
  const [loadingTripodLogList, setLoadingTripodLogList] = useState(false);

  const _handleGetFilterDataTripodLog = useCallback(async () => {
    await dispatch(tripodThunks.getLogFilterDataThunk());
  }, []);
  const _handleGetListTripodLog = useCallback(
    async () => {
      setLoadingTripodLogList(true);
      await dispatch(tripodThunks.getTripodLogListThunk(param));
      setLoadingTripodLogList(false);
    },
    [param]
  );
  const _handleChangeInput = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      clearTimeout(timer);
      _handleChangeFilter();
    }, 800);
  };
  const _handleChangeFilter = () => {
    let from, to;
    const {
      checkin_type,
      device_id,
      device_ip,
      fullname,
      station_id,
      sync_state,
      time,
      username,
      verify_mode
    } = form.getFieldsValue();
    if (time) {
      from = dayjs(time[0]).format("YYYY-MM-DD HH:mm:ss");
      to = dayjs(time[1]).format("YYYY-MM-DD HH:mm:ss");
    }
    setParam(prev => ({
      ...prev,
      from,
      to,
      station_id,
      checkin_type,
      device_id,
      device_ip,
      fullname,
      sync_state,
      username,
      verify_mode,
      page: 1,
      size: 20
    }));
  };
  const _handleDisabledDate = current => {
    return current && current > dayjs().endOf("day");
  };

  const onChangeParam = param => {
    if (!param.page && !param.size) {
      param.page = PAGINATION.page;
      param.size = PAGINATION.size;
    }
    setParam(prev => ({ ...prev, ...param }));
  };

  useEffect(
    () => {
      _handleGetFilterDataTripodLog();
      _handleGetListTripodLog();
    },
    [_handleGetFilterDataTripodLog, _handleGetListTripodLog]
  );
  return (
    <Row gutter={[8, 8]}>
      <Col span={24}>
        <Card
          bodyStyle={{ paddingBottom: "0" }}
          size="small"
          style={CARD_STYLE}
        >
          <Row align="middle" justify="space-between" span={24}>
            <Form
              form={form}
              layout={"vertical"}
              style={{ width: "100%" }}
              initialValues={{
                time: [
                  dayjs("00:00:00", "HH:mm:ss"),
                  dayjs("23:59:59", "HH:mm:ss")
                ]
              }}
            >
              <Row gutter={[8]}>
                <Col className="gutter-row" span={4}>
                  <Form.Item label={"Thời gian"} name={"time"}>
                    <RangePicker
                      disabledDate={_handleDisabledDate}
                      showTime
                      format={TIME_FORMAT_DATE_TIME}
                      onChange={_handleChangeFilter}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={2}>
                  <Form.Item label="Username" name="username">
                    <Input
                      placeholder={"Username"}
                      onChange={_handleChangeInput}
                    />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={2}>
                  <Form.Item label="Tên nhân viên" name="fullname">
                    <Input
                      placeholder={"Tên nhân viên"}
                      onChange={_handleChangeInput}
                    />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={3}>
                  <Form.Item label="Kho" name="station_id">
                    <AppBaseSelect
                      allowConvert={true}
                      placeholder="Kho"
                      dataSource={stations}
                      valueKey="station_id"
                      labelKey="station_name"
                      onChange={_handleChangeFilter}
                      filterOption={(input, option) =>
                        _.includes(
                          _.toLower(removeVietnameseTones(option.label)), 
                          _.toLower(removeVietnameseTones(input))
                          )
                      }
                    />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={3}>
                  <Form.Item label="SN" name="device_id">
                    <AppBaseSelect
                      allowConvert={true}
                      placeholder="SN"
                      dataSource={_.map(device_ids, device_id => ({
                        key: device_id,
                        value: device_id
                      }))}
                      valueKey="key"
                      labelKey="value"
                      onChange={_handleChangeFilter}
                    />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={2}>
                  <Form.Item label="IP thiết bị" name="device_ip">
                    <AppBaseSelect
                      allowConvert={true}
                      placeholder="IP thiết bị"
                      dataSource={_.map(device_ips, device_ip => ({
                        key: device_ip,
                        value: device_ip
                      }))}
                      valueKey="key"
                      labelKey="value"
                      onChange={_handleChangeFilter}
                    />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={2}>
                  <Form.Item label="Loại xác minh" name="verify_mode">
                    <AppBaseSelect
                      allowConvert={true}
                      placeholder="Loại xác minh"
                      dataSource={convertObjToArrObj(verify_modes)}
                      valueKey="key"
                      labelKey="value"
                      onChange={_handleChangeFilter}
                    />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={3}>
                  <Form.Item label="Trạng thái In/Out" name="checkin_type">
                    <AppBaseSelect
                      allowConvert={true}
                      placeholder="Trạng thái In/Out"
                      dataSource={convertObjToArrObj(checkin_types)}
                      valueKey="key"
                      labelKey="value"
                      onChange={_handleChangeFilter}
                    />
                  </Form.Item>
                </Col>

                <Col className="gutter-row" span={3}>
                  <Form.Item label="Trạng thái Log" name="sync_state">
                    <AppBaseSelect
                      allowConvert={true}
                      placeholder="Trạng thái Log"
                      dataSource={convertObjToArrObj(sync_states)}
                      valueKey="key"
                      labelKey="value"
                      onChange={_handleChangeFilter}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Row>
        </Card>
      </Col>
      <Col span={24}>
        <TripodLogList
          loading={loadingTripodLogList}
          dataSource={dataSource}
          verify_modes={verify_modes}
          total={total}
          param={param}
          checkin_types={checkin_types}
          sync_states={sync_states}
          onChangeParam={onChangeParam}
          onClickRenew={_handleGetListTripodLog}
        />
      </Col>
    </Row>
  );
}

export default React.memo(TripodLog);
